import {
    AppBar,
    Box,
    Button,
    Card,
    CardHeader,
    Container,
    createStyles,
    Drawer,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Paper,
    Theme,
    Toolbar,
    Typography,
} from '@material-ui/core';
import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useImperativeHandle,
    forwardRef,
    ForwardRefRenderFunction,
    Dispatch,
    SetStateAction,
    Fragment,
} from 'react';
import {
    oper as v_oper,
    basic,
    Values,
    material,
    order as v_order,
    SNACKBAR_TIME,
} from '../../request/values';
import { Waypoint } from 'react-waypoint';

import NumberFormat from 'react-number-format';

import clsx from 'clsx';

import { COLORS } from '../Theme';

// Icon

import { useSnackbar } from 'notistack';
import axios from 'axios';
import { SIcon } from '../Icon';
import { DialogInput, DialogDeleteCompany, DialogInputText } from '../Dialog';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';
import TitleBar from '../header/TitleBar';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: 0,
            height: '88vh',
            paddingTop: '3.5vh',
            background: `${COLORS.WHITE}`,
        },
        cardContainer: {
            width: '80%',
            margin: 'auto',
        },
        materialItem: {
            borderRadius: 12,
            margin: 'auto',
            marginBottom: '1.5vh',

            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
            width: '90%',
            paddingTop: '2.2vh',
            paddingBottom: '2.2vh',
        },

        companyAsset: {
            float: 'right',
        },

        itemProcessing: {
            backgroundColor: `${COLORS.LIGHT_GREY}`,
        },

        list: {
            width: '100%',
            height: '75vh',
            overflowY: 'auto',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '4vw',
            paddingTop: '3vh',
        },
        grid: {
            maxHeight: '80vh',
            overflowY: 'auto',
        },
        paper: {
            padding: theme.spacing(1),
            // margin: 'auto'
        },
        materialImage: {
            // height: 60,
            // width: 60
            textAlign: 'center',
            margin: 'auto',
            '& img': {
                width: '11vw',
            },
        },
        materialList: {
            width: '90%',
            maxWidth: 360,
        },
        materialCompanyName: {
            fontSize: '3vw',
            fontWeight: 'bold',
            fontFamily: 'NanumB',
            color: `${COLORS.WATER_BLUE}`,
        },
        orderSheet: {
            // height : 'calc(100%- 64px)',
            // top: 64
            height: '100vh',
        },
        empty: {
            height: '62vh',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
                width: '35vw',
                height: '35vw',
                marginBottom: '2.5vh',
                opacity: 0.4,
            },
            '& h1': {
                color: `${COLORS.DOWN}`,
            },
        },

        xIconContainer: {
            position: 'absolute',
            top: '-8px',
            right: '-8px',
            [theme.breakpoints.up('md')]: {
                top: '-14px',
                right: '-14px',
            },
            '& #xIconButton': {
                display: 'box',
                all: 'unset',
                border: 'none',
                background: 'none',
                '& #xIcon': {
                    display: 'box',
                    width: '20px',
                    [theme.breakpoints.up('md')]: {
                        width: '32px',
                    },
                },
            },
        },
        infoContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '& #companyList': {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                '& #companyName': {
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'left',
                    padding: '5px',
                    '& #editButton': {
                        display: 'box',
                        all: 'unset',
                        border: 'none',
                        background: 'none',
                        marginLeft: '1.5vw',
                        '& #editIcon': {
                            display: 'box',
                            width: '3vw',
                            maxWidth: '24px',
                        },
                    },
                },
            },
            '& #buttonContainer': {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: '3vh',
                gap: '20px',
                '& #loanButton': {
                    borderRadius: '5px',
                    backgroundColor: `${COLORS.WATER_BLUE}`,
                    width: '50%',
                    padding: '10px',
                    '& #loanButtonText': {
                        color: `${COLORS.WHITE}`,
                        fontFamily: 'NanumB',
                        fontWeight: 'bold',
                        fontSize: '12px',
                        [theme.breakpoints.up('md')]: {
                            fontSize: '18px',
                        },
                    },
                },
            },
        },
    })
);

type iCompanyList = {
    company_num: string;
    company_name: string;
    company_stock: string;
    member_name: string;
};

export interface refHandle {
    refreshCartList: () => void;
    handleOpen: () => void;
}

export interface InputProps {
    oper: any;
}

const OperCompanyList: ForwardRefRenderFunction<refHandle, InputProps> = (
    props: any,
    ref: any
) => {
    const classes = useStyles();

    const [company, setCompany] = useState<iCompanyList[]>([]);
    const [dialog, setDialog] = useState<number>(-1); // -1 = false, 0 > index
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const history = useHistory();

    const count = 20;
    let max_count: number = 999;
    const loader = useRef(null);
    const [page, setPage] = useState(-count);

    const { oper } = props;

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    const getCompanyList = () => {
        axios({
            method: 'POST',
            data: {
                classCode: oper.classCode,
            },
            withCredentials: true,
            url: SERVER + v_oper.oper + v_oper.company_list,
            headers: {
                'Access-Control-Allow-Origin': basic.server_url,
                mode: 'cors',
                'Access-Control-Allow-Headers':
                    'Origin, X-Requested-With, Content-Type, Accept',
            },
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log('data?', data);
                if (data.code == Values.SUCCESS_CODE) {
                    setCompany(data.data);
                }
                console.log('company?', company);
            });
    };

    useEffect(() => {
        if (page >= 0) {
            getCompanyList();
        }
    }, [page]);

    return (
        <Container component="main" className={classes.container}>
            <TitleBar history={history} title="기업관리" titleIcon="order" />

            <div className={classes.cardContainer}>
                <Typography
                    variant="h1"
                    align="center"
                    style={{ color: `${COLORS.BROWNISH_GREY}` }}
                >
                    창을 누르시면 각 기업을 상세히 관리할 수 있습니다.
                </Typography>
                <List className={classes.list}>
                    {company != null ? (
                        company.map((item: any, index: number) => {
                            return (
                                <ListItem
                                    className={classes.materialItem}
                                    alignItems="center"
                                >
                                    <CompanyItem
                                        item={item}
                                        index={index}
                                        //getCompanyList={getCompanyList()}
                                        getCompanyList={() => getCompanyList()}
                                    />
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/order.webp" />
                                <Typography variant="h1">
                                    관리할 기업이 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader} />
                </List>
            </div>
        </Container>
    );
};

const CompanyItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();

    const { item, index, getCompanyList } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [upInput, setUpInput] = useState<boolean>(false);
    const [downInput, setDownInput] = useState<boolean>(false);
    const [deleteDialog, setDeleteDialog] = useState<boolean>(false);
    const [companyInfo, setCompanyInfo] = useState();
    const [editDialog, setEditDialog] = useState<boolean>(false);

    const handleDialogClose = (key: string) => {
        if (key === 'upInput') setUpInput((prevState) => !prevState);
        else if (key === 'downInput') setDownInput((prevState) => !prevState);
        else if (key === 'deleteDialog')
            setDeleteDialog((prevState) => !prevState);
        else if (key === 'editDialog') setEditDialog((prevState) => !prevState);
    };

    const handleDialogOpen = (key: string) => {
        if (key === 'upInput') setUpInput(true);
        else if (key === 'downInput') setDownInput(true);
        else if (key === 'editDialog') setEditDialog(true);
    };

    const handleDeleteDialogOpen = async () => {
        console.log('open delete dialog');
        await getCompanyInfo();
        setDeleteDialog(true);
    };

    const raiseMoney = (money: number) => {
        axios({
            method: 'POST',
            withCredentials: true,
            data: {
                companyNum: item.company_num,
                money: money,
            },
            url: SERVER + v_oper.oper + v_oper.company_raise,
        })
            .then((res: any) => {
                if (res.data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_ASSET_UPDATE_STR, {
                        variant: 'success',
                        translate: 'no',
                    });
                }
                console.log('res? ', res);
                getCompanyList();
            })
            .catch(() => {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                    variant: 'warning',
                    translate: 'no',
                });
            });
        handleDialogClose('upInput');
    };

    const disraiseMoney = (money: number) => {
        axios({
            method: 'POST',
            withCredentials: true,
            data: {
                companyNum: item.company_num,
                money: money,
            },
            url: SERVER + v_oper.oper + v_oper.company_lower,
        })
            .then((res: any) => {
                if (res.data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_ASSET_UPDATE_STR, {
                        variant: 'success',
                        translate: 'no',
                    });
                }
                console.log('res? ', res);
                getCompanyList();
            })
            .catch(() => {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                    variant: 'warning',
                    translate: 'no',
                });
            });
        handleDialogClose('downInput');
    };

    const getCompanyInfo = async () => {
        try {
            const response = await axios({
                method: 'GET',
                withCredentials: true,
                params: {
                    companyNum: item.company_num,
                },
                url: SERVER + v_oper.oper + v_oper.company_info,
            });
            console.log(response.data);
            setCompanyInfo(response.data.students);
        } catch (error) {
            console.error('Error fetching company info:', error);
        }
    };

    const deleteCompany = () => {
        axios({
            method: 'POST',
            withCredentials: true,
            data: {
                companyNum: item.company_num,
            },
            url: SERVER + v_oper.oper + v_oper.company_delete,
        })
            .then((res) => {
                console.log('data? ', res.data);
                enqueueSnackbar(ToastStr.COMPANY_DELETE_SUCCESS_STR, {
                    variant: 'success',
                    translate: 'no',
                });
                handleDialogClose('deleteDialog');
                getCompanyList();
            })
            .catch(() => {
                enqueueSnackbar(ToastStr.COMPANY_DELETE_FAIL_STR, {
                    variant: 'warning',
                    translate: 'no',
                });
            });
    };

    const editCompanyName = (name: string) => {
        axios({
            method: 'POST',
            withCredentials: true,
            data: {
                companyNum: item.company_num,
                name: name,
            },
            url: SERVER + v_oper.oper + v_oper.company_info_update,
        })
            .then((res: any) => {
                console.log('post edit? ', res.data);
                getCompanyList();
            })
            .catch(() => {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                    variant: 'warning',
                    translate: 'no',
                });
            });
        handleDialogClose('editDialog');
    };

    return (
        <Grid container alignContent="center">
            <Grid className={classes.xIconContainer}>
                <button id="xIconButton" onClick={handleDeleteDialogOpen}>
                    <img src="/images/x_icon.png" id="xIcon" />
                </button>
            </Grid>
            <div className={classes.infoContainer}>
                <Grid id="companyList">
                    <Grid id="companyName">
                        <Typography
                            display="inline"
                            variant="h3"
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                                fontWeight: 'bold',
                            }}
                        >
                            {`${item.company_name}`}
                        </Typography>
                        <button
                            id="editButton"
                            onClick={() => handleDialogOpen('editDialog')}
                        >
                            <img id="editIcon" src="/images/edit_icon.svg" />
                        </button>
                    </Grid>

                    <Grid>
                        <Typography
                            className={classes.companyAsset}
                            display="inline"
                            variant="h3"
                            style={{
                                color: `${COLORS.WATER_BLUE}`,
                                fontWeight: 'bold',
                            }}
                        >
                            현금 보유량 : {`${item.company_stock}`} 원
                        </Typography>
                    </Grid>
                </Grid>
                <div id="buttonContainer">
                    <Button
                        id="loanButton"
                        onClick={() => handleDialogOpen('upInput')}
                    >
                        <Typography variant="h3" id="loanButtonText">
                            자산 올리기
                        </Typography>
                    </Button>
                    <Button
                        id="loanButton"
                        onClick={() => handleDialogOpen('downInput')}
                    >
                        <Typography variant="h3" id="loanButtonText">
                            자산 내리기
                        </Typography>
                    </Button>

                    <DialogInput
                        open={upInput}
                        handleClose={() => handleDialogClose('upInput')}
                        title="올릴 자산을 입력하세요"
                        yesConfirm={(e: any, money: number) =>
                            raiseMoney(money)
                        }
                        noConfirm={() => handleDialogClose('upInput')}
                    />

                    <DialogInput
                        open={downInput}
                        handleClose={() => handleDialogClose('downInput')}
                        title="내릴 자산을 입력하세요"
                        yesConfirm={(e: any, money: number) =>
                            disraiseMoney(money)
                        }
                        noConfirm={() => handleDialogClose('downInput')}
                    />

                    <DialogInputText
                        open={editDialog}
                        handleClose={() => handleDialogClose('editDialog')}
                        title="변경할 기업명을 입력하세요"
                        yesConfirm={(e: any, name: string) =>
                            editCompanyName(name)
                        }
                        noConfirm={() => handleDialogClose('editDialog')}
                    />

                    <DialogDeleteCompany
                        open={deleteDialog}
                        handleClose={() => handleDialogClose('deleteDialog')}
                        yesConfirm={() => deleteCompany()}
                        noConfirm={() => handleDialogClose('deleteDialog')}
                        title="기업을 삭제하시겠습니까?"
                        context={companyInfo}
                    />
                </div>
            </div>
        </Grid>
    );
};

export default OperCompanyList;
